import { type CreditReason, creditReasonZod } from "@nlc/shared-types";
import { z } from "zod";

export const CREDIT_REASON_OPTIONS: { id: CreditReason; label: string }[] = [
  { id: "qa-issue", label: "QA issue" },
  { id: "customer-satisfaction", label: "Customer satisfaction" },
  { id: "turnaround-delay", label: "Turnaround delay" },
  { id: "billing-error", label: "Billing error" },
  { id: "goodwill", label: "Goodwill" },
  { id: "other", label: "Other" },
];

export const creditReasonFieldsSchema = {
  note: z.string().trim(),
  reason: z.enum(creditReasonZod.options, {
    errorMap: () => ({ message: "Select a reason" }),
  }),
};
